type RequestErrorLike = {
  message?: string
  response?: {
    status?: number
  }
}

export type AnalysesLpuRequestErrorDialog = {
  title: string
  text: string
}

function isRequestErrorLike(error: unknown): error is RequestErrorLike {
  return typeof error === 'object' && error !== null
}

function isNetworkDisconnect(error: unknown): boolean {
  if (!process.env.IS_CLIENT || !isRequestErrorLike(error)) {
    return false
  }

  return error.response?.status === 0
    || !window.navigator.onLine
    || error.message === 'Network Error'
}

export function getAnalysesLpuRequestErrorDialog(error: unknown): AnalysesLpuRequestErrorDialog {
  if (isNetworkDisconnect(error)) {
    return {
      title: 'Нет интернета',
      text: 'Проверьте соединение и обновите страницу.',
    }
  }

  return {
    title: 'Что-то пошло не так',
    text: 'Попробуйте немного подождать и обновите страницу.',
  }
}
